<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <small class="badge-role bg-primary"><strong>{{role}}</strong></small>&nbsp;{{ user.fullname }}
      <img
        :src="user.avatar ? user.avatar['100x'] : 'https://exportedu.ru/images/pics/user-pic.jpg'"
        class="img-avatar"
      />
    </template>
    <template slot="dropdown">
      <b-dropdown-header
        tag="div"
        class="text-center">
      </b-dropdown-header>
      <b-dropdown-item @click="logout()"><i class="fa fa-lock" /> Выход</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import * as AppStorage from '../storage/appstorage';
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
        user: JSON.parse(AppStorage.get('user')),
        role: 'МЕНЕДЖЕР'
    }
  },
    mounted() {
        if(this.user.roles.indexOf('ROLE_SUPER_ADMIN') > -1) {
            this.role = 'АДМИНИСТРАТОР';
        }

        if(this.user.roles.indexOf('ROLE_HEAD') > -1) {
            this.role = 'РУКОВОДИТЕЛЬ';
        }
    },
  methods: {
      logout() {
          localStorage.clear();
          this.$router.push('/login');
      }
  }
}
</script>
<style>
  .badge-role {
    border-radius: 7px;
    padding: 2px 7px;
  }
</style>
